/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetAgentInfoModel,
  IGetAgentInfoRequest,
  IMappers,
  IGetAgentInfoResponse,
  IGetAgentInfoResponseError,
  TGetAgentInfoResponse,
} from './types';

const defaultConfig: TGetAgentInfoModel = {
  apiType: 'private',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'agent-card',
  pathApi: '/v1/get-agent-info/',
  hostType: 'api',
} as TGetAgentInfoModel;

function createGetAgentInfoModel(parameters: IGetAgentInfoRequest): TGetAgentInfoModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetAgentInfoOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetAgentInfoRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetAgentInfo<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetAgentInfoOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetAgentInfoResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetAgentInfoModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetAgentInfoResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetAgentInfoResponseError);
    }
  }

  return { response, statusCode } as TGetAgentInfoResponse;
}

export { defaultConfig, createGetAgentInfoModel, fetchGetAgentInfo };
